import {
  AMBIENT_PREDATOR_LEVEL_MAX_SCORE,
  DAY_NIGHT_AMBIENT_PREDATOR_MODIFIER,
  SEASON_AMBIENT_PREDATOR_MODIFIER,
  TERRAIN_AMBIENT_PREDATOR_BASE,
} from "../../models/config/balance.ts";
import type { DayNightPhase } from "../../models/dayNightPhase.ts";
import type { Season } from "../../models/season.ts";
import type { TileTerrain } from "../../models/worldState.ts";

/** Ambient tile predator severity (display-only; distinct from random-event predators). */
export type AmbientPredatorLevel = "none" | "low" | "medium" | "high";

function getTileAmbientPredatorScore(
  terrain: TileTerrain,
  season: Season,
  phase: DayNightPhase,
): number {
  return (
    TERRAIN_AMBIENT_PREDATOR_BASE[terrain] +
    SEASON_AMBIENT_PREDATOR_MODIFIER[season] +
    DAY_NIGHT_AMBIENT_PREDATOR_MODIFIER[phase]
  );
}

function resolveAmbientPredatorLevelFromScore(
  score: number,
): AmbientPredatorLevel {
  const max = AMBIENT_PREDATOR_LEVEL_MAX_SCORE;
  if (score <= max.none) {
    return "none";
  }
  if (score <= max.low) {
    return "low";
  }
  if (score <= max.medium) {
    return "medium";
  }
  return "high";
}

/** Display-only ambient predator level for a tile. */
export function getTileAmbientPredatorLevel(
  terrain: TileTerrain,
  season: Season,
  phase: DayNightPhase,
): AmbientPredatorLevel {
  return resolveAmbientPredatorLevelFromScore(
    getTileAmbientPredatorScore(terrain, season, phase),
  );
}
